import { Component, Inject, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { UploadService } from '@app/common/services/upload.service';
import { AuthService } from '@app/common/services/auth.service';

@Component({
  selector: 'view-settings',
  templateUrl: './view-settings.component.html',
})
export class ViewSettingsComponent implements OnInit {

  @Input()
  project: any;
  progress: number;
  authToken = this.authService.getToken();
  restBaseUrl = this.authService.getActiveApplicationRestUrl();

  constructor(
    private cdr: ChangeDetectorRef,
    private uploadService: UploadService,
    private authService: AuthService,
  ) {
  }

  ngOnInit() {

  }

  onProjectUpload() {
    const input = document.createElement('input');
    input.type = 'file';

    // Omezení na ZIP soubory
    // Používáme jak MIME typ, tak příponu pro maximální kompatibilitu
    input.accept = '.zip,application/zip,application/x-zip-compressed';

    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files[0];
      if (file) {

        const sendData: any = {
          file: file,
          filename: file.name,
        };
        this.progress = 0;
        this.uploadService.upload({
          url: this.restBaseUrl + '/view/project-layer',
          data: sendData,
          headers: {Authorization: this.authToken}
        }).progress(event => {
          this.progress = (100.0 * event.loaded / event.total);
          this.cdr.markForCheck();
        }).success(data => {
          this.progress = -2;
          this.project.viewMapUploadedTimestamp = new Date();
          this.cdr.markForCheck();
        }).error(() => {
          this.progress = -1;
          this.cdr.markForCheck();
        });
      }
    };

    input.click();
  }
}
